<div class="modal-header">
  <h1 class="modal-title">Enter Verification Code</h1>
</div>
<div class="modal-body">
  <div class="code-sent-text">A verification code has been sent via text message to <strong>{{number | mask: '(999) 999-9999'}}</strong></div>
  <div class="verification-code" [ngClass]="{'error': codeError || nullCodeError}">
    @if (codeError) {
      <div class="alert alert-danger" role="alert">The code entered is incorrect. Please try again.</div>
    }
    @if (nullCodeError) {
      <div class="alert alert-danger" role="alert">Please enter the verification code.</div>
    }
    <!-- <input type="text" name="sms-pincode-input" id="sms-pincode-input" pin-code-input="code" (keyup)="keycount()"> -->
    <code-input [isNonDigitsCode]="false" [codeLength]="4" [code]="code" (codeChanged)="keycount($event)">
    </code-input>
  </div>
  <div class="didnt-get-code">Did not receive a code? <a (click)="resendCode()" tabindex="0">Resend code</a></div>
</div>
<div class="modal-footer text-right">
  <button type="button" class="btn cancel-button" (click)="closeThisDialog();cancelCode()">Cancel</button>
  <button (click)="confirmCode()" class="btn next-button" [disabled]="!code || code.length < 4">Continue</button>
</div>
